import type { ReactNode } from 'react';
import Breadcrumbs from '@/components/feature/Breadcrumbs';

interface PageHeaderProps {
  eyebrow: string;
  title: string;
  description: string;
  crumbs: { label: string; to?: string }[];
  aside?: ReactNode;
}

export default function PageHeader({ eyebrow, title, description, crumbs, aside }: PageHeaderProps) {
  return (
    <section className="w-full border-b border-background-200 bg-background-100">
      <div className="w-full px-4 py-6 md:px-8 md:py-8">
        <Breadcrumbs items={crumbs} />
        <div className="mt-4 flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <p className="font-label text-[11px] font-semibold uppercase tracking-[0.2em] text-primary-600">
              {eyebrow}
            </p>
            <h1 className="mt-2 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-[32px]">
              {title}
            </h1>
            <p className="mt-2.5 text-sm leading-relaxed text-foreground-600">{description}</p>
          </div>
          {aside}
        </div>
      </div>
    </section>
  );
}